module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/appeal_top_bubble-4204edf7a934b91545d361cde8092a7f.png";